"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSN_REGEX = exports.PRIMARY_MIN_AGE = exports.AUTH_MIN_AGE = exports.NAME_REGEX = exports.NAME_MAX_LENGTH = exports.NAME_MIN_LENGTH = exports.COMMON_PROVIDERS = exports.EMAIL_REGEX = exports.EMAIL_MAX_LENGTH = void 0;
exports.EMAIL_MAX_LENGTH = 254;
exports.EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|net|co|edu|org|us|es|gov|me|ca|biz|fr|uk|eu|au|io|mil|info|au|nz|tv|de|jp|cn|es|in|it|nl|se|ch|ru|br|mx|ar|kr|tw|hk|sg|dk|no|fi|be|at|be|cz|ie|pl|pt|tr|za|gr|hu|is|ro)$/;
exports.COMMON_PROVIDERS = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "icloud.com",
];
exports.NAME_MIN_LENGTH = 2;
exports.NAME_MAX_LENGTH = 30;
exports.NAME_REGEX = /^[A-Za-zñíáúóüéÑÍÁÚÓÜÉ`'‘’\-\ ,.]*$/;
exports.AUTH_MIN_AGE = 13;
exports.PRIMARY_MIN_AGE = 18;
exports.SSN_REGEX = /^(?!666|000)[0-8][0-9_]{2}-(?!00)[0-9_]{2}-(?!0000)[0-9_]{4}$/;
